import { render } from "./ApplicationHeatingOfLenta.vue?vue&type=template&id=cf974e4e&scoped=true"
import script from "./ApplicationHeatingOfLenta.vue?vue&type=script&lang=js"
export * from "./ApplicationHeatingOfLenta.vue?vue&type=script&lang=js"

import "./ApplicationHeatingOfLenta.vue?vue&type=style&index=0&id=cf974e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf974e4e"]])

export default __exports__